<app-categorias [explorationMode]="'mapa'" [explorar]="true"></app-categorias>
